/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG} from '../../../helpers'
import {Dropdown1} from '../../content/dropdown/Dropdown1'

type Props = {
  className: string
}

const ListsWidget3: React.FC<any> = ({className, links}) => {
  const ml2: React.CSSProperties = { marginLeft: '0.5rem' }

  const mapExtension = (link: string) => {
    const format = link.replaceAll('*1', '/').replaceAll('*2', '.').replaceAll('*3', ',').replaceAll('*4', ';').replaceAll('*5', ':').split('.')
    
    return format[format.length-1]
  }

  const b64toBlob = (b64Data: any, contentType: any ='', sliceSize: any =512) => {
    const byteCharacters = atob(b64Data)
    const byteArrays = []
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)
  
      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }
  
      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }
  
    const blob = new Blob(byteArrays, {type: contentType})
    return blob
  }

  const contentType = 'image/png'
  const b64Data = 'iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=='

  const downloadFile = (dataLink: any) => {
    // const blob = new Blob([dataLink.ba], { type: 'application/vnd.ms-excel' })
    // const filename = dataLink.headers['content-disposition'].split('"')[1]
    
    // const dataB64: any[] = dataLink.base64.split(';')
    // const type: string = dataB64[0].substring(5)
    // const b64: string = dataB64[1].substring(7)
    // const type: string = dataB64[0].substring(5)
    // const b64: string = dataB64[1].substring(7)
    
    let tipo: string = dataLink.link.replaceAll('*1', '/').replaceAll('*2', '.').replaceAll('*3', ',').replaceAll('*4', ';').replaceAll('*5', ':')
    const blob: any = b64toBlob(dataLink.bas64, tipo)
    const blobUrl: any = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = blobUrl
    link.download = dataLink.texto
    link.click()
    URL.revokeObjectURL(link.href)
  }

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0'>
        <h3 className='card-title fw-bolder text-dark'>Links de Interés</h3>
        <div className='card-toolbar'>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
          </button>
          {/* <Dropdown1 /> */}
        </div>
      </div>
      <div className='card-body pt-2'>
        {
          links &&
          links.length &&
          links.map((link: any, key: number) => {
            return (
              <div className='d-flex align-items-center mb-8' key={key}>
                <i className="bi bi-link"></i>
                <div className='flex-grow-1' style={ml2}>
                  <a
                    href=''
                    className='text-gray-800 text-hover-primary fw-bolder fs-6'
                    onClick={(e) => {
                      e.preventDefault()
                      downloadFile(link)
                    }
                  }>
                    {link.texto}
                  </a>
                </div>
                <span className='badge badge-light-success fs-8 fw-bolder'>{mapExtension(link.link)}</span>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

interface IListsWidget3 {
  links: any[]
  className: string | StyleSheet
}

export {ListsWidget3}
